// constants
export const MAX_POSITION_DIFF = 5; // pixels how far the user can click from a point or line to consider it a hit, also how far the cursor can be moved between mouse down and up to consider it a click
export const CLICK_TIMESPAN = 200; // time in milliseconds which can last between mouse down and up to consider it a click

// draw options
export const DEFAULT_LINE_COLOR = "black";
export const DEFAULT_FILL_COLOR = "red";
export const DEFAULT_LINE_WIDTH = 1;

export const DEFAULT_RUBBERLINE_WIDTH = 1;
export const DEFAULT_RUBBERLINE_COLOR = "black";
export const DEFAULT_RUBBERLINE_DOT_PERIMETER_COLOR = "black";
export const DEFAULT_RUBBERLINE_DOT_PERIMETER_WIDTH = 1;
export const DEFAULT_RUBBERLINE_DOT_FILL_COLOR = "red";

export const DEFAULT_TEXT_COLOR = "black";
export const DEFAULT_TEXT_OUTLINE_WIDTH = 1;

// line styles
export const LINE_SOLID: number[] = [];
export const LINE_DOTTED: number[] = [2, 2];
export const LINE_DASHED: number[] = [5, 5];

// debug
export const SHOW_HIT_AREA = true;
export const SHOW_SNAP_AREA = true;